import { CertificateCreateData, RelativeDistignuishedName } from "./types";

// Объект содержащий свойства всех основных атрибутов
export const CERTIFICATE_ATTRIBUTES = [
  { name: "name", oid: "2.5.4.3", alias: "CN", description: true },
  { name: "department", oid: "2.5.4.11", alias: "OU" },
  { name: "organization", oid: "2.5.4.10", alias: "O" },
  { name: "country", oid: "2.5.4.6", alias: "C" },
  { name: "email", oid: "1.2.840.113549.1.9.1", alias: "E" },
  { name: "position", oid: "2.5.4.12", alias: "2.5.4.12" },
];

// Функция создания списка RDN(Relative Distinguished Names, относительных уникальных имён), которой мы используем при создании DN.
export const createRDN = (certificateData: CertificateCreateData) => {
  const rdnList: Array<RelativeDistignuishedName> = [];

  CERTIFICATE_ATTRIBUTES.forEach((attribute) => {
    const attributeName = attribute.name;

    certificateData[attributeName as keyof typeof certificateData] &&
      rdnList.push({
        alias: attribute.alias,
        value: certificateData[attributeName as keyof typeof certificateData],
      });
  });

  return rdnList;
};

// Функция подготовки DN(Distinguished Name, уникальное имя) из списка RDN
export const prepareDistinguishedName = (
  certificateData: CertificateCreateData
): string => {
  const relativeDistinguishedNameList = createRDN(certificateData);
  let distinguishedName = "";

  relativeDistinguishedNameList.forEach((rdn) => {
    if (rdn.value) {
      if (distinguishedName.length !== 0) {
        distinguishedName += ",";
      }

      distinguishedName = `${
        distinguishedName + rdn.alias
      }="${rdn.value.replace(/"/g, '""')}"`;
    }
  });

  return distinguishedName;
};
